import gql from 'graphql-tag';

const dokumenFragment = gql `
  fragment dokumenFragment on Dokumen {
    uuid
    dokumen_id
    nama
    lokasi
    created_at
    updated_at
    file_url
    attribute
  }
`;

const CREATE = gql `
  mutation($input: DokumenCreateInput!) {
    createDokumenManually(input: $input) {
      ...selectedField
    }
  }
  ${dokumenFragment}
`;

const UPDATE = gql `
  mutation($id: ID, $input: DokumenUpdateInput!) {
    dokumenUpdate(id: $id,input: $input) {
      ...selectedField
    }
  }
  ${dokumenFragment}
`;

const FIND = gql `
  query find($uuid: String!){
    dokumenByUuid(uuid: $uuid){
      ...dokumenFragment
    }
  }
  ${dokumenFragment}
`

export {
  CREATE,
  UPDATE,
  FIND
};
